// extracted by mini-css-extract-plugin
module.exports = {"cls1":"StyledComponents-TextContainer_cls1__By0k_","cls2":"StyledComponents-TextContainer_cls2__cOR8b StyledComponents-TextContainer_cls1__By0k_"};